<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M457.308-457.308H220.001v-45.384h237.307v-237.307h45.384v237.307h237.307v45.384H502.692v237.307h-45.384v-237.307Z"/></svg>
</template>
